declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
    gtag: (...args: unknown[]) => void;
  }
}

export enum LoveLanguage {
  A = 'A', // Words of Affirmation
  B = 'B', // Quality Time
  C = 'C', // Receiving Gifts
  D = 'D', // Acts of Service
  E = 'E', // Physical Touch
}

export interface Option {
  key: string;
  type: LoveLanguage;
}

export interface Question {
  id: number;
  options: [Option, Option];
}

export type Answers = Record<number, LoveLanguage>;
